import axios from "axios";

const instance = axios.create({
  baseURL: "https://s2.linerapay.com.br",
  headers: {
    Authorization: "",
    "Access-Control-Allow-Origin": "*",
  },
});

export default instance;
